class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector("cart-drawer");
    this.modal = document.getElementById("backorder-modal");

    // Get available stock from the quantity input's data attribute
    const quantityInput = document.querySelector('input[name="quantity"]');
    this.availableStock = quantityInput
      ? parseInt(quantityInput.dataset.availableStock) || 0
      : 0;
    console.log("Initial available stock:", {
      availableStock: this.availableStock,
      dataAttribute: quantityInput?.dataset.availableStock,
      rawValue: quantityInput?.getAttribute("data-available-stock"),
    });

    // Setup modal handlers
    if (this.modal) {
      this.modal
        .querySelector('[data-action="proceed-backorder"]')
        .addEventListener("click", () => {
          this.proceedWithBackorder();
        });

      this.modal
        .querySelector('[data-action="cancel-backorder"]')
        .addEventListener("click", () => {
          this.hideModal();
        });
    }

    // Listen for our custom add to cart event
    this.addEventListener("product:add-to-cart", () => {
      this.onSubmitHandler(new Event("submit"));
    });
  }

  showModal(availableStock, requestedQuantity) {
    if (!this.modal) return;

    const backorderQuantity = requestedQuantity - availableStock;
    console.log("Modal values:", {
      availableStock,
      requestedQuantity,
      backorderQuantity,
      elementStock: this.availableStock,
      rawDataAttribute: this.querySelector(
        'input[name="quantity"]',
      )?.getAttribute("data-available-stock"),
    });

    this.modal.querySelector("#available-stock").textContent = availableStock;
    this.modal.querySelector("#backorder-quantity").textContent =
      backorderQuantity;
    this.modal.classList.remove("hidden");
  }

  hideModal() {
    if (!this.modal) return;
    this.modal.classList.add("hidden");
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();

    // Find quantity input by form attribute
    const quantityInput = document.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.error("Quantity input not found");
      this.submitForm();
      return;
    }

    const quantity = parseInt(quantityInput.value);
    const availableStock = parseInt(quantityInput.dataset.availableStock) || 0;

    console.log("Form submission:", {
      quantity,
      availableStock,
      rawDataAttribute: quantityInput.getAttribute("data-available-stock"),
    });

    // Check for alternate warehouse first
    const locationInventory = document.querySelector("location-inventory");
    if (locationInventory) {
      const stockData = await locationInventory.getStockData(
        quantityInput.dataset.sku,
      );
      const customerWarehouseStock = stockData.find(
        (stock) =>
          stock.warehouse_code === locationInventory.dataset.customerWarehouse,
      );
      const customerWarehouseQty =
        customerWarehouseStock?.availability === "In Stock"
          ? customerWarehouseStock.qty_on_hand
          : 0;

      // Calculate total available stock across all warehouses
      const totalAvailableStock = stockData.reduce((total, stock) => {
        return stock.availability === "In Stock"
          ? total + stock.qty_on_hand
          : total;
      }, 0);

      // If quantity exceeds total available stock, show backorder modal
      if (quantity > totalAvailableStock) {
        console.log("Showing backorder modal");
        this.showModal(totalAvailableStock, quantity);
        return;
      }

      // If quantity exceeds customer warehouse stock but is available elsewhere, show alternate warehouse modal
      if (quantity > customerWarehouseQty) {
        const alternateWarehouseModal = document.getElementById(
          "warehouse-availability-modal",
        );
        if (alternateWarehouseModal) {
          alternateWarehouseModal.classList.remove("hidden");
          return;
        }
      }
    }

    this.submitForm();
  }

  proceedWithBackorder() {
    // Add the backorder property to the form
    let input = this.form.querySelector('input[name="properties[backorder]"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[backorder]";
      this.form.appendChild(input);
    }
    input.value = "true";

    // Hide modal
    this.hideModal();

    // Submit the form
    this.submitForm();
  }

  submitForm() {
    // Dispatch pre-submit event
    const beforeAddEvent = new CustomEvent("product:before-add", {
      bubbles: true,
      cancelable: true,
    });

    // If the event was prevented, stop submission
    if (!this.dispatchEvent(beforeAddEvent)) {
      return;
    }

    const submitButton = this.querySelector('[type="submit"]');
    submitButton.classList.add("loading");
    submitButton.disabled = true;

    // Add loading spinner
    const originalContent = submitButton.innerHTML;
    submitButton.innerHTML = `
      <i class="fa-solid fa-circle-notch fa-spin text-sm mr-2"></i>
      Adding to cart...
    `;

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cartDrawer.loadCart();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove("loading");
        submitButton.disabled = false;
        submitButton.innerHTML = originalContent;
        this.cartDrawer.open();
      });
  }
}

customElements.define("product-form", ProductForm);
